import { handleActions } from "redux-actions";
import { push } from "react-router-redux";
import { initialize as initializeForm } from "redux-form";
import { ToastStore } from "react-toasts";
import Swal from "sweetalert2";
import { getMe } from "../usuario/usuario";
import { api } from "api";

// ------------------------------------
// Constants
// ------------------------------------
export const BANCOS = "BANCO_BANCOS";
export const BANCO = "BANCO_BANCO";
export const PAGE = "BANCO_PAGE";
export const BUSCADOR = "BANCO_BUSCADOR";
export const SORT = "BANCO_SORT";
export const LOADER = "BANCO_LOADER";

export const constants = {};

const endpoint = "bancos";
// ------------------------------------
// Actions
// ------------------------------------
export const listar =
    (page = 1) =>
    (dispatch, getStore) => {
        dispatch(setLoader(true));
        const store = getStore();
        const bancos = store.bancos;
        const { ordering, search } = bancos;
        api.get(endpoint, { page, ordering, search })
            .then((data) => {
                if (data) {
                    dispatch(setBancos(data));
                }
                dispatch(setPage(page));
            })
            .catch((err) => {})
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

export const buscar = (search) => (dispatch) => {
    dispatch(setBuscador(search));
    dispatch(listar());
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.bancos.page;
    dispatch(listar(page));
};

export const crear = (data) => (dispatch) => {
    dispatch(setLoader(true));
    api.post(endpoint, data)
        .then((resp) => {
            ToastStore.success("Datos almacenados correctamente");
            dispatch(push("/bancos"));
        })
        .catch((err) => {
            Swal(
                "ERROR",
                "Ha ocurrido un error, verifique los datos y vuelva a intentar.",
                "error"
            );
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${endpoint}/${id}`)
        .then((resp) => {
            dispatch(setBancoLeer(resp));
        })
        .catch((err) => {
            Swal("ERROR", "Ha ocurrido un error.", "error");
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${endpoint}/${id}`, data)
        .then((resp) => {
            ToastStore.success("Datos almacenados correctamente");
            dispatch(push("/bancos"));
        })
        .catch((err) => {
            Swal(
                "ERROR",
                "Ha ocurrido un error, verifique los datos y vuelva a intentar.",
                "error"
            );
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`${endpoint}/${id}`)
        .then((data) => {
            ToastStore.success("Registro eliminado.");
            dispatch(listar());
        })
        .catch((error) => {
            Swal(
                "ERROR",
                "Ha ocurrido un error, verifique que no hay usuarios asignados a la sucursal y vuelva a intentar.",
                "error"
            );
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

// ------------------------------------
// PureActions
// ------------------------------------
export const setBancos = (data) => ({
    type: BANCOS,
    data,
});
export const setPage = (page) => ({
    type: PAGE,
    page,
});
export const setBuscador = (search) => ({
    type: BUSCADOR,
    search,
});
export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});
export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});
export const setBancoLeer = (bancos) => ({
    type: BANCO,
    bancos,
});

export const actions = {
    listar,
    buscar,
    sortChange,
    eliminar,
    crear,
    editar,
    leer,
};

// ------------------------------------
// Reducers
// ------------------------------------
export const reducers = {
    [BANCOS]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [BANCO]: (state, { bancos }) => {
        return {
            ...state,
            bancos,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [BUSCADOR]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {},
    bancos: {},
    page: 1,
    search: "",
    ordering: "",
    loader: false,
};

export default handleActions(reducers, initialState);
